import { render, staticRenderFns } from "./Episode_tvshow.vue?vue&type=template&id=592a8164"
import script from "./Episode_tvshow.vue?vue&type=script&lang=js"
export * from "./Episode_tvshow.vue?vue&type=script&lang=js"
import style0 from "./Episode_tvshow.vue?vue&type=style&index=0&id=592a8164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports